import React, { createContext, useReducer } from "react";
import { setTokens, clearTokens, getAccessToken, getRefreshToken } from "../utils/axiosConfig";

type State = { isLoggedIn: boolean };

type Action =
  | { type: "LOGIN"; accessToken: string; refreshToken?: string }
  | { type: "LOGOUT" };

const initialState: State = { isLoggedIn: !!getAccessToken() };

function reducer(state: State, action: Action): State {
  switch (action.type) {
    case "LOGIN": {
      setTokens(action.accessToken, action.refreshToken);
      return { isLoggedIn: true };
    }
    case "LOGOUT": {
      clearTokens();
      return { isLoggedIn: false };
    }
    default:
      return state;
  }
}

export const AuthContext = createContext<{ state: State; dispatch: React.Dispatch<Action> }>({
  state: initialState, dispatch: () => {}
});

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return <AuthContext.Provider value={{ state, dispatch }}>{children}</AuthContext.Provider>;
};
